export const customsDeclarations = {
  title: '海关申报',
  resourceName: '海关申报',
  titles: {
    list: '海关申报列表',
    detail: '海关申报详情',
    create: '新增海关申报',
    edit: '编辑海关申报',
    addQuick: '快速添加',
  },
  sections: {
    linkage: '批次与 HS 编码',
    product: '商品与技术参数',
    origin: '产地与制造商',
    commercial: '数量与价格',
    tax: '税费',
    note: '备注',
    audit: '系统',
  },
  filter: {
    all: '全部批次',
  },
  hints: {
    imageLines: '每行一个或用逗号分隔',
  },
  fields: {
    loHang: '批次',
    maHs: 'HS 编码',
    trongLuong: '重量 (kg)',
    tenYeuCauXuatHoaDon: '发票抬头要求',
    tenThuongHieu: '品牌',
    model: '型号',
    moTaSanPham: '商品描述',
    hinhAnhSanPham: '商品图片',
    linkSanPham: '商品链接',
    thongSoKyThuat: '技术参数',
    kichThuoc: '尺寸',
    chieuDai: '长',
    chieuRong: '宽',
    chieuCao: '高',
    theTich: '体积',
    congSuat: '功率/规格',
    nhaSanXuat: '制造商',
    diaChiNhaMay: '工厂地址',
    nuocXuatXu: '原产国',
    soLuong: '数量',
    donVi: '单位',
    donGia: '单价',
    thanhTien: '金额',
    loaiTienTe: '币种',
    thueVat: '增值税 (%)',
    soTienThue: '税额',
    ghiChu: '备注',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: '操作',
  },
  messages: {
    noData: '暂无海关申报',
    exportSuccess: '海关申报导出成功',
    exportFailed: '海关申报导出失败',
  },
}
